// #region Global Imports
import * as React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
// #endregion Global Imports

// #region Local Imports
import { Button } from "@Components/Basic";
import { IFacebookButton } from "./FacebookButton";
import { FacebookService } from "@Services";
import { AccountActions } from "@Actions";
import { ActionConsts } from "@Definitions";
// #endregion Local Imports

const IconFigure = styled.i`
    font-size: 24px;
    color: ${({ theme }) => theme.colors.facebook};
    padding-top: 3px;
`;

export const FacebookButton: React.FunctionComponent<IFacebookButton.IProps> = props => {
    const { t } = props;
    const dispatch = useDispatch();

    const handleClick = async () => {
        const fbResponse = await FacebookService.login();

        dispatch({
            payload: fbResponse.authResponse?.access_token,
            type: ActionConsts.Account.FacebookToken,
        });

        dispatch(
            AccountActions.LoginWithFacebook({
                body: {
                    accessToken: fbResponse.authResponse?.access_token || "",
                },
            })
        );
    };

    return (
        <Button
            styleType="facebook"
            size="medium"
            icon={<IconFigure className="icon facebook-icon ml-3" />}
            iconPosition="right"
            onClick={handleClick}
        >
            {t("common:Facebook ile bağlan")}
        </Button>
    );
};
